import MigrationMode from '../../schema/innerSchema/MigrationMode';

/**
 * Returns MigrationMode based on the value of the input (number or string)
 * Returns null if the expected input is not given
 */
export default function getMigrationMode(migrationMode: any): MigrationMode {
    switch (migrationMode) {
        case 0:
        case 'Unknown': {
            return MigrationMode.Unknown;
        }

        case 1:
        case 'Griffin': {
            return MigrationMode.Griffin;
        }

        case 2:
        case 'Utah': {
            return MigrationMode.Utah;
        }

        default: {
            return null;
        }
    }
}
